var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.artistList != '')?_c('div',{staticClass:"movieMargin"},[_vm._m(0),_c('div',{staticClass:"row"},_vm._l((_vm.artistList),function(artist,index){return _c('CollabCard',{key:index,attrs:{"artist":artist}})}),1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artist__legend_bar"},[_c('strong',[_vm._v("Холбоотой уран бүтээлчид / түүхэн хүмүүс")])])
}]

export { render, staticRenderFns }